export default {
    modal_not_connected: 'Estás sin conexão',
    modal_not_connected_message:
        'Para acessar o aplicativo e aproveitar todas as suas funcionalidades, certifique-se de estar conectado a uma rede Wi-Fi ou de dados móveis.',

    //Splash
    splash_message: 'Plataforma de comunicação e treinamento',

    //TTCC
    accept_ttcc: 'Aceitar termos e condições',

    //Login
    welcome: 'Bem-vindo!',
    welcome_message: 'Dots, seu novo aliado tecnológico em comunicação e treinamento.',
    username: 'Nome de usuário',
    password: 'Senha',
    code: 'Código',
    recover_password: 'Recuperar senha',
    log_in: 'Entrar',
    log_in_biometrics: 'Entrar com dados biométricos',
    create_user: 'Criar usuário',
    recover_access_to_account: 'Digite seu nome de usuário para recuperar acesso à sua conta',
    back: 'Voltar',
    enter_new_password: 'Digite o código e sua nova senha',
    enter_code: 'Digite o código',
    new_password: 'Nova senha',
    repeat_new_password: 'Repita a nova senha',
    validate: 'Validar',
    complete_all_fields: 'Complete todos os campos',
    passwords_do_not_match: 'As senhas não coincidem',
    user_created_successfully: 'Usuário criado com sucesso',
    create_user: 'Criar usuário',
    required_fields: 'Campos obrigatórios',
    confirm_your_email: 'Confirme seu e-mail',
    confirm_your_phone: 'Confirme seu telefone',
    confirm_password: 'Confirme sua senha',
    modifying_email: 'Você está modificando seu e-mail',
    validate_code: 'Validar código',
    code_sent_successfully: 'Código enviado com sucesso',
    password_reset: 'Sua senha foi redefinida com sucesso',
    enter_confirmation_code: 'Digite seu código de confirmação',
    enter_your_new_email: 'Insira seu novo e-mail',
    //nuevos al 01-08-2024
    user_does_not_exist: 'Ops! Não encontramos sua conta',
    contact_the_administrator:
        'Parece que o usuário que você inseriu não existe.\nVerifique se está escrito corretamente\nou entre em contato com o administrador.',
    invalid_user_or_pass: 'Nome de usuário e/ou senha inválidos',
    info_is_not_correct: 'Algumas das informações estão incorretas, por favor, tente novamente.',
    enter_user: 'Por favor, insira um nome de usuário',
    nonexistent_user: 'Usuário inexistente. Por favor, tente novamente.',
    incorrect_code: 'Código incorreto',
    change_saved_successfully: 'Alteração salva com sucesso',
    pass_changed_successfully: 'A senha foi alterada com sucesso',
    check_your_email: 'Verifique seu e-mail para inserir o código de validação',
    eight_characters: '*Deve conter mais de 8 caracteres',
    one_uppercase_letter: '*Deve conter pelo menos 1 letra maiúscula',
    one_special_character: '*Deve conter pelo menos 1 caractere especial (@,$,!,#,?)',
    pass_requirements:
        'Você deve atender aos seguintes requisitos:\n\n*Deve conter mais de 8 caracteres\n*Deve conter pelo menos 1 letra maiúscula\n*Deve conter pelo menos 1 caractere especial (ex: $, !, #, ?)',
    select_date: 'Selecione uma data',
    cannot_create_password: 'Não é possível criar a senha',
    complete_your_details: 'Complete seus dados para continuar',
    validate_code: 'Validar código',
    enter_valid_number: 'Você deve inserir um número válido',
    complete_numbers:
        'O prefixo "15" deve ser removido para que o número final tenha um total de 13 dígitos, exemplo: +54 9 XXX XXX XXXX, você deve completar os 10 dígitos restantes.',

    //Profile
    insufficient_permissions: 'Permissões insuficientes',
    permissions_are_required: 'Permissões são necessárias para acessar a câmera e a galeria de fotos.',
    choose_font: 'Escolher fonte',
    where_do_you_want: 'De onde você quer escolher a imagem?',
    camera: 'Câmera',
    gallery: 'Galeria',
    edit_photo: 'Editar foto',
    cancel: 'Cancelar',
    save: 'Salvar',
    app: 'App',
    support: 'Suporte',
    other: 'Outro',
    contact_channel: 'Canal de contato',
    select_the_contact_channel: 'Selecione o canal de contato',
    subject: 'Assunto',
    write_the_subject: 'Escreva o assunto',
    message: 'Mensagem',
    write_a_comment: 'Escreva um comentário',
    send: 'Enviar',
    sent_successfully: 'Enviado com sucesso',
    thank_you_for_leaving_us_your_comments: 'Obrigado por nos deixar seus comentários, entraremos em contato em breve.',
    close: 'Fechar',
    check_for_update: 'Verificar atualização',
    clear_cache: 'Limpar cache',
    delete_account: 'Excluir conta',
    log_out: 'Sair',
    notifications: 'Notificações',
    insufficient_permissions: 'Permissões insuficientes',
    permissions_to_access: 'Permissões são necessárias para acessar a câmera e a galeria de fotos.',
    choose_font: 'Escolher fonte',
    select_the_image: 'De onde você quer escolher a imagem?',
    change_language: 'Mudar idioma',
    change_language_title: 'Importante!',
    change_language_message:
        'Para realizar esta ação é necessário ter conexão com a internet. Isso excluirá o conteúdo baixado para uso offline. Observe que a alteração afetará apenas o conteúdo do aplicativo e não a estrutura do aplicativo, que depende do idioma do seu dispositivo.',
    logout_not_available: 'Logout não disponível',
    cant_logout: 'Você não pode fazer logout no momento porque está sem conexão à internet. Por favor, verifique sua conexão e tente novamente.',
    //nuevos al 01-08-2024
    cache_cleared: 'Cache limpo com sucesso',
    deletes_the_content:
        'Esta ação exclui o conteúdo baixado para uso do aplicativo no modo offline. Certifique-se de estar conectado para continuar navegando.',
    error_uploading_image: 'Erro ao fazer upload da imagem: ',
    there_was_an_error: 'Ocorreu um erro ao fazer upload da imagem. Por favor, tente novamente.',
    //nuevos al 21-11-2024
    email: 'E-mail',
    phone: 'Telefone',
    name: 'Nome',
    last_name: 'Sobrenome',
    role: 'Função',
    verify: 'Verificar',
    verified: 'Verificado',
    contact_channels: 'Canais de contato',
    editing_your_email: 'Você está editando seu e-mail',
    editing_your_phone: 'Você está editando seu número de telefone',
    modifying_your_email:
        'Você está modificando seu e-mail, você receberá um código no seu e-mail para inseri-lo. Se ainda não recebeu o código, por favor, verifique novamente.',
    modifying_your_phone:
        'Você está modificando seu número de celular, você receberá um código por SMS para inseri-lo. Se ainda não recebeu o código, por favor, verifique novamente.',

    //Notifications
    all: 'Todas',
    unread: 'Não lidas',
    read: 'Lidas',
    seen: 'Visto',
    notifications: 'Notificações',
    here_you_will_find: 'Aqui você encontrará todos os alertas e notificações!',
    mark_all_read: 'Marcar todas como lidas',
    you_have_no_notifications: 'Você não tem notificações!',
    you_will_soon_start: 'Em breve você começará a receber novas comunicações',

    //Buscador
    enter_your_search: 'Digite sua busca',
    no_results: 'Sem resultados',
    search_content: 'Pesquise o conteúdo que lhe interessa.',
    see: 'Ver',
    results_in: 'resultados em',
    see_less_results: 'Ver menos resultados',
    all: 'Todos',
    wall: 'Mural',
    learning: 'Aprendizado',
    benefits: 'Benefícios',
    portfolio: 'Portfólio',
    retry: 'Tentar novamente',
    locked: 'Bloqueado',
    pending: 'Pendente',
    seen: 'Visto',
    approved: 'Aprovado',

    //Posts
    see_them: 'Ver todos',
    _comments: ' comentários',
    reactions_from_other_users: 'Reações de outros usuários',
    not_connected_to_the_network: 'Você não está conectado à rede',
    comment: 'Comentar',
    comments: 'Comentários',
    write_a_comment: 'Escreva um comentário',
    no_content: 'Sem conteúdo',
    not_connected_to_the_network: 'Você não está conectado à rede',
    reaction: 'Reação',
    reactions: 'Reações',
    first_comment: 'Seja o primeiro a comentar!',
    no_comment: 'Ainda não há comentários nesta postagem.',
    write_a_comment: 'Escreva um comentário',
    no_publications: 'Sem publicações',
    no_post_to_read: 'Você não tem postagens para ler.',
    views: 'visualizações',
    reply: 'Responder',
    see: 'Ver',
    more_answers: 'mais respostas',
    hide: 'Ocultar',
    answers: ' respostas',
    no_reactions: 'Ainda não há reações!',
    leave_your_reaction: 'Seja o primeiro a deixar sua reação.',
    //nuevos al 01-08-2024
    full_survey: 'Você completou a pesquisa!',
    thanks_for_participating: 'Obrigado por participar! Fique de olho na parede para mais atualizações.',
    sent_automatically: 'Será enviado automaticamente quando você restabelecer a conexão.',
    no_post_saved: 'Ainda não há publicações guardadas',
    see_your_favorite_content: 'Aqui você verá seu conteúdo favorito.',
    //fechas
    instant: 'alguns instantes atrás',
    hourFirst: 'há ',
    hour: ' hora',
    hours: ' horas',
    day: ' dia',
    days: ' dias',

    //Learning
    congratulations: 'Parabéns!',
    you_approved: 'Você aprovou',
    you_completed: 'Você completou este curso',
    you_disapproved: 'Avaliação reprovada',
    score: 'Pontuação:',
    return_to_course: 'Voltar ao início',
    retry: 'Tentar novamente',
    it_is_available: 'Agora está disponível',
    total_course_evaluation: 'Avaliação total do curso',
    evaluate_me: 'Avaliar-me',
    completed_the_course: 'Você completou o curso',
    pending_approval: 'Aprovação pendente',
    return: 'Voltar',
    continue_course: 'Continuar curso',
    you_have_made: 'Você completou',
    of_the_course: 'do curso',
    locked: 'Bloqueado',
    pending: 'Pendente',
    seen: 'Visto',
    complete: 'Completo',
    reprobate: 'Reprovado',
    sync_pend: 'Sincronização pendente',
    in_progress: 'Em progresso',
    perform_evaluation: 'Realizar avaliação',
    next_content: 'Próximo conteúdo',
    you_completed_all: 'Você completou todo o conteúdo',
    final_evaluation: 'Avaliação final',
    retry_mayus: 'Tentar novamente',
    see_more: '...ver mais',
    see_less: '...ver menos',
    back_to_course: 'Voltar ao curso',
    click_to_see: 'Clique para ver',
    //Evaluaciones
    evaluation: 'Avaliação:',
    of: ' de ',
    loading_evaluation: 'Carregando avaliação...',
    select_option: 'Você deve selecionar uma opção para continuar',
    select_one_answer: 'Por favor, selecione pelo menos uma resposta para cada pergunta.',
    exit_evaluation: 'Você deseja sair da avaliação?',
    your_answers_will_not_be_saved: 'Se você sair agora, suas respostas não serão salvas e você não receberá uma nota',
    continue_evaluation: 'Continuar avaliação',
    leave_anyway: 'Sair mesmo assim',
    try_again: 'Tentar novamente!',
    passed_the_evaluation: 'Você passou na avaliação',
    start_the_course_again: 'Você não obteve a nota suficiente para passar na avaliação. Comece o curso novamente para passá-lo.',
    evaluation_pending_approval: 'Avaliação pendente de aprovação',
    notification_result_evaluation: 'Em breve você receberá uma notificação com o resultado da sua avaliação',
    write_here: 'Escreva aqui...',
    close: 'Fechar',
    confirm: 'Confirmar',
    sync_pending: 'Sincronização pendente',
    view_certificate: 'Ver certificado',

    // nuevos al 27-01-2025
    course_download_in_process: 'Download do curso em andamento',
    course_is_downloading:
        'Por favor, aguarde alguns segundos. O curso está sendo baixado para que você possa acessar todo o conteúdo offline sem problemas.',
    downloaded_course: 'Curso baixado com sucesso',
    you_can_train_offline: 'Pronto! Agora você pode treinar offline.',
    delete_offline_course: 'Você deseja excluir o download offline deste curso?',
    not_view_course_offline: 'Você não poderá visualizar este curso offline.',
    course_is_not_available: 'O curso não está mais disponível...',
    not_available_offline: 'Não está mais disponível offline, mas você pode baixá-lo novamente quando precisar.',
    content_download_in_process: 'Download de conteúdo em andamento',
    content_is_downloading: 'Por favor, aguarde alguns segundos. O conteúdo está sendo baixado para que você possa acessá-lo offline sem problemas.',
    downloaded_content: 'Conteúdo baixado com sucesso',
    delete_offline_content: 'Você deseja excluir o conteúdo offline?',
    not_view_content_offline: 'Ao excluí-lo, você não poderá mais acessar o conteúdo offline.',
    content_is_not_available: 'O conteúdo não está mais disponível...',
    download_offline: 'Baixar offline',
    available_offline: 'Disponível offline',
    delete: 'Excluir',
    //Stores
    your_progress_in_stores: 'Seu progresso nas lojas',
    map: 'Mapa',
    daily_survey: 'Pesquisa diária',
    survey: 'Pesquisa',
    matutino: 'Matutino',
    vespertino: 'Vespertino',
    form: 'Formulário',
    enter_a_number: 'Digite um número',
    campaign_expiration: 'Expiração da campanha:',
    store_indicators: 'Indicadores da loja',
    last_days: 'Relevante para os últimos 30 dias',
    main_indicators: 'Conheça o progresso dos principais indicadores nas lojas',
    store_information: 'Encontre informações relevantes para atender aos níveis ótimos da Perfect Store na loja',
    perform_executions: 'Realize as execuções a seguir para saber a situação da loja',
    pending_mayus: 'Pendente',
    approved_mayus: 'Aprovado',
    in_review_mayus: 'Em revisão',
    redo_mayus: 'Refazer',
    visited_mayus: 'Visitado',
    visited_mayus_sync: 'VISITADO SYNC',
    visited_store_mayus: 'LOJAS VISITADAS',
    checkin_realized_sync: 'LOJAS VISITADAS SYNC',
    moderation_mayus: 'Moderação',
    review_mayus: 'Revisão',
    in_progress_mayus: 'Em progresso',
    sync_pend_mayus: 'Sincronização pendente',
    locked_mayus: 'Bloqueado',
    complete_mayus: 'Completo',
    perfect_store: 'Loja perfeita',
    execution: 'Execução',
    vouchers: 'Vouchers',
    send: 'Enviar',
    requires: 'Requer',
    variation: 'Variação',
    validity: 'Validade:',
    points: 'pontos',
    voucher_canceled: 'Voucher cancelado',
    you_can_try_again: 'Não se preocupe! Você pode tentar novamente.',
    voucher_successful: 'Voucher concluído com sucesso!',
    successful_promo: 'Promoção concluída com sucesso!',
    voucher_pending: 'Voucher pendente',
    wait_for_the_validation: 'Aguarde a validação do seu voucher',
    your_code_is_being_scanned: 'Seu código está sendo escaneado ⏳',
    view_qr: 'Ver QR',
    return_to_store: 'Voltar à loja',
    stores_objective: 'Isso deve cumprir o objetivo das lojas.',
    welcome_stores: 'Bem-vindo às lojas!',
    tip_day: 'Aqui você pode visitar as lojas do seu dia, realizar as pesquisas correspondentes e revisar seu progresso.',
    close_mayus: 'Fechar',
    select_form: 'Selecione um formulário para começar',
    select_one_form: 'Você deve selecionar um formulário para começar a pesquisa.',
    answer_all_questions: 'Você deve responder a todas as perguntas para continuar.',
    schedule_not_found: 'Agenda não encontrada para hoje.',
    form_not_found: 'Formulário não encontrado na agenda.',
    send: 'Enviar',
    check_in: 'Check-in',
    check_out: 'Check-out',
    check_out_done: 'Check-out concluído',
    off_route: 'Você está fora da rota, clique aqui para voltar',
    search_barcode: 'Pesquisar por código de barras',
    no_agenda_today: 'Você não tem agenda para hoje!',
    no_agenda_week: 'Você não tem agenda para a semana!',
    no_information_today: 'Você não tem agenda para esta data, se tiver alguma dúvida, entre em contato com seu supervisor.',
    no_information_week: 'Não estamos recebendo informações para o seu usuário, se tiver alguma dúvida, entre em contato com seu supervisor.',
    //nuevos al 01-08-2024
    not_have_camera_permissions: 'Você não tem permissões de câmera',
    activate_from_settings: 'Ative isso nas configurações do seu dispositivo para continuar.',
    modify_permissions: 'Modificar permissões',
    complete_fields: 'Complete os seguintes campos para criar uma loja',
    create: 'Criar',
    store_name: 'Nome da loja',
    enter_store_name: 'Digite o nome da loja',
    sore_address: 'Endereço',
    enter_sore_address: 'Digite o endereço da loja',
    cluster: 'Cluster',
    store_phone: 'Telefone',
    enter_sore_phone: 'Digite o telefone da loja',
    activate_survey: 'Para ativar a pesquisa 1.1 Vespertino, você deve completar os objetivos das lojas. Objetivos: ',
    inactive_vespertino: 'Vespertino inativo',
    active_vespertino: 'Vespertino ativo',
    completed_your_mandatory_objectives: 'Você completou seus objetivos obrigatórios do dia, agora você pode realizar seu Vespertino.',
    complete_now: 'Completar agora',
    perform_later: 'Realizar mais tarde',
    back_to_your_agenda: 'Deseja voltar à sua agenda do dia?',
    return_to_the_current_day: 'Você está visualizando atividades dos dias anteriores, se tocar continuar, você voltará ao dia atual: ',
    continue: 'Continuar',
    reached_your_goal: 'Você alcançou seu objetivo!',
    search_by_barcode: 'Buscar por código de barras',
    scan_the_barcode: 'Escaneie o código de barras de qualquer produto\nna lista deste levantamento.',
    return_to_form: 'Voltar ao Formulário',
    product_not_found: 'Produto não encontrado',
    code_does_not_match: 'O código não corresponde a nenhum produto relacionado a este formulário.',
    search_another_product: 'Buscar outro produto',
    form_submitted_successfully: ' foi bem sucedido!',
    send_new_survey: 'Se desejar, você pode enviar uma nova pesquisa.',
    no_agenda_for_today: 'Não há agenda para hoje!',
    consult_your_supervisor: 'Você não tem agenda para esta data, em caso de dúvida consulte seu supervisor.',
    visiting_your_store: 'Você está visitando sua loja ',
    you_can_check_out: 'Você pode fazer o check-out sem completar a pesquisa: ',
    you_met_the_goal: 'Você atingiu o objetivo, não é necessário completar o formulário.',
    you_must_complete_the_survey: 'Para fazer o check-out, você deve completar a pesquisa: ',
    checkin_blocked: 'Check-in bloqueado',
    close_the_open_checkin: 'Para continuar, você deve fechar o check-in aberto.',
    close_the_checkin_opened_in: 'Para continuar, você deve fechar o check-in aberto em: ',
    checkin_out_of_range: 'Check-in fora de alcance',
    more_meters_from_the_store: 'Você está a mais de 150 metros da loja.',
    now_is_your_turn: 'Agora é a sua vez!',
    surveys_in_progress: 'Você tem pesquisas em andamento: ',
    unfinished_surveys: 'Você tem pesquisas não concluídas: ',
    want_to_checkout: 'Tem certeza de que deseja fazer o check-out?',
    selected_store: 'Loja selecionada',
    checkout_blocked: 'Check-out bloqueado',
    uncompleted_forms: 'Você tem formulários não concluídos!',
    checkout_anyway: 'Você quer fazer o check-out de qualquer maneira?',
    go_to_survey: 'Ir para a pesquisa',
    take_the_survey: 'Agora você pode realizar a pesquisa!',
    validity: 'Validade: ',
    search_store: 'Pesquisar loja...',
    no_results_for_your_search: 'Nenhum resultado para sua busca',
    find_another_store: 'Encontre outra loja',
    //nuevos al 21-11-2024
    loading: 'Carregando...',
    error_getting_data: 'Erro ao obter os dados.',
    no_information_to_display: 'Não há informações para exibir.',
    unzipping: 'Descompactando...',
    saving: 'Salvando',
    loading_stores: 'Carregando lojas...',
    getting_stores: 'Obtendo lojas...',
    request_has_failed: 'Número máximo de tentativas alcançado. A solicitação falhou.',
    a_few_minutes: 'Carregando lojas...\nEste processo pode levar alguns minutos.',
    //nuevos al 27-01-2025
    assets_download_completed: 'Download dos recursos do Perfect Store concluído',
    perfect_store_download: 'Download da foto de sucesso do Perfect Store concluído',
    perfect_store_error: 'Erro ao baixar os recursos do Perfect Store',
    connection_interrupted: 'Conexão interrompida, a foto de sucesso será descompactada quando a conexão for restaurada',
    decompressing_perfect_store: 'Descompactando Loja Perfeita',
    downloading_perfect_store: 'Baixando Loja Perfeita',
    saving_perfect_store: 'Salvando Loja Perfeita',
    remain_downloaded: '\nFaltam para baixar ',
    assets: ' recursos.',
    download_complete: 'Download concluído',

    //Portfolio
    no_brands_to_show: 'Nenhuma marca para mostrar',
    no_products_to_show: 'Nenhum produto para mostrar',
    try_again_later: 'Tente novamente mais tarde',
    portfolio: 'Portfólio',
    select_one: 'Escolha uma de nossas marcas para ver seus produtos e serviços.',
    learn_about: 'Conheça a gama completa de produtos e serviços em nosso app.',
    //nuevos al 01-08-2024
    brand: 'Marca',
    description: 'Descrição',
    ingredients: 'Ingredientes',
    data_sheet: 'Ficha técnica',

    //Benefits
    points_can_be_exchanged: 'podem ser trocados por:',
    approved: 'Aprovado',
    cancelled: 'Cancelado',
    pending: 'Pendente',
    redeemed: 'Resgatado',
    added_points: 'Pontos adicionados',
    all: 'Todos',
    my_points: 'Meus pontos',
    your_points: 'Seus pontos',
    delivered: 'Entregue',
    no_benefits: 'Ainda não há benefícios',
    add_points: 'Ganhe pontos com suas interações e resgate-os',
    no_history: 'Ainda não há histórico',
    redeem_your_points: 'Resgate seus pontos e você verá seu histórico de benefícios aqui',
    pending_approval: 'Aprovação pendente',
    when_it_is_approved: 'Quando for aprovado, você verá refletido no seu histórico de benefícios',
    unredeemed_benefit: 'Benefício não resgatado',
    you_dont_have_enough_points: 'Você não tem pontos suficientes para resgatar este benefício',
    accept: 'Aceitar',
    units_available: ' unidades disponíveis',
    redeem_benefit: 'Resgatar benefício',
    benefits_mayus: 'Benefícios',
    history: 'Histórico',
    there_was_a_mistake: 'Houve um erro',

    //Vouchers
    complete_to_redeem_the_voucher: 'Complete para resgatar o voucher',
    valid_until: 'Válido até:',
    quantity_purchased: 'Quantidade comprada:',
    redeem: 'Resgatar',
    lumps: 'Lotes',
    voucher_redeemed: 'Voucher resgatado com sucesso',
    error_redeeming_voucher: 'Ocorreu um erro ao resgatar o voucher. Tente novamente.',
    validate_and_redeem_vouchers: 'Validar e resgatar vouchers',
    to_get_started: 'Para começar, insira ou escaneie o QR do seu voucher com sua câmera',
    write_your_code: 'Digite seu código...',
    validate: 'Validar',
    back_to_store: 'Voltar à loja',
    scan_qr: 'Escanear o QR',
    scan_on_the_voucher: 'Para começar, escaneie o QR do voucher',
    view_history: 'Ver histórico',
    voucher_history: 'Histórico de vouchers',
    voucher_history_description:
        'Este histórico permite que você acompanhe com precisão as trocas realizadas, facilitando o acompanhamento e a gestão de suas recompensas acumuladas.',
    see_more: 'Ver mais',
    see_less: 'Ver menos',

    //Faltantes
    upload_image: 'Carregar imagem',
    uploaded_image: 'Imagem carregada',
    photo: 'Foto',
    edit: 'Editar',
    delete: 'Excluir',
    enter_a_comment: 'Insira um comentário',
    enter_a_value: 'Insira um valor',
    want_to_check_out: 'Tem certeza de que deseja fazer o check-out?',
    not_check_in_again: 'Uma vez confirmado, você não poderá fazer o check-in novamente até sua próxima visita.',

    //Alert
    alert: 'Alerta',
    enter_characters: 'Você deve inserir 10 caracteres após o prefixo',
    numerical_field: 'O campo a ser editado deve ser numérico, sem espaços ou letras.',
    enter_date_of_birth: 'Insira uma data de nascimento válida no formato YYYY-MM-DD.',
    session_expired: 'Sessão expirada',
    your_session_has_expired: 'Sua sessão expirou. Por favor, tente novamente.',
    error: 'Erro',
    error_occurred: 'Ocorreu um erro ao tentar alterar a senha.',
    email_verification_code_incorrect: 'O código de verificação do e-mail está incorreto.',
    phone_verification_code_incorrect: 'O código de verificação do telefone está incorreto.',
    no_checkin_found: 'Check-in não encontrado.',

    //trivia
    your_position: 'Your position',
    play_again: 'Play again!',
    next: 'Next',
    position: 'Position',
    Questions: 'Question:',
    answer_right: 'The correct answer is:',
    game_completed_title1: 'Game completed!',
    game_completed_title2: 'Congratulations!',
    game_completed_title3: 'You finished the trivia.',
    game_completed_title4: 'Ready to see your results? Discover how many answers you got right and challenge yourself to improve your score.',
    game_unfinished_title1: 'Time is up for answering this or the questions.',
    game_unfinished_title2: "But don't worry, keep playing and show your knowledge in the next one!",
    tomorrow_again: 'New attempt tomorrow!',
    complete: 'Complete',
}
